var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 0.384766V7.38477M7 7.38477V14.3848M7 7.38477H14M7 7.38477H0",
  stroke: "#141415"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03IDAuMzg0NzY2VjcuMzg0NzdNNyA3LjM4NDc3VjE0LjM4NDhNNyA3LjM4NDc3SDE0TTcgNy4zODQ3N0gwIiBzdHJva2U9IiMxNDE0MTUiIC8+Cjwvc3ZnPg==";